
import MarketAnalysisChart from "@/components/marketAnalysis/MarketAnalysisChart";
import MarketAnalysisKpis from "@/components/marketAnalysis/MarketAnalysisKpis";
import MarketAnalysisPerformance from "@/components/marketAnalysis/MarketAnalysisPerformance";

export default {
    name: 'MarketDataSection',

    components: {
        MarketAnalysisChart,
        MarketAnalysisKpis,
        MarketAnalysisPerformance,
    },

    head() {
        return {
            titleTemplate: `%s | ${this.$t('pages.marketAnalysis.marketdata.head.titleTemplate')}`,
            title: this.$t('pages.marketAnalysis.marketdata.head.title'),
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.$t('pages.marketAnalysis.marketdata.head.description'),
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    content: this.$t('pages.marketAnalysis.marketdata.head.ogTitle'),
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content: this.$t('pages.marketAnalysis.marketdata.head.ogDescription'),
                },
                {
                    hid: "twitter:title",
                    name: "twitter:title",
                    content: this.$t('pages.marketAnalysis.marketdata.head.twitterTitle'),
                },
                {
                    hid: "twitter:description",
                    name: "twitter:description",
                    content: this.$t('pages.marketAnalysis.marketdata.head.twitterDescription'),
                },
            ],  
        }
    },
}
